import { render, staticRenderFns } from "./channelClassItem.vue?vue&type=template&id=2c86f2fe&scoped=true&"
import script from "./channelClassItem.vue?vue&type=script&lang=js&"
export * from "./channelClassItem.vue?vue&type=script&lang=js&"
import style0 from "./channelClassItem.vue?vue&type=style&index=0&id=2c86f2fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86f2fe",
  null
  
)

export default component.exports